// Date 2020-07-24 14:09:42

import inspectionSchedule from "@/store/em/inspection/InspectionScheduleStore.js";
import inspectionScheduleEquipment from "@/store/em/inspection/InspectionScheduleEquipmentStore.js";
import inspectionWorkOrder from "@/store/em/inspection/InspectionWorkOrderStore.js";
import inspectionRecord from "@/store/em/inspection/InspectionRecordStore.js";
import inspectionCategory from "@/store/em/inspection/InspectionCategoryStore.js";
import inspectionResult from "@/store/em/inspection/InspectionResultStore.js";
import inspectionValueType from "@/store/em/inspection/InspectionValueTypeStore.js";
import inspectionWay from "@/store/em/inspection/InspectionWayStore.js";
import inspectionStandard from "@/store/em/inspection/InspectionStandardStore.js";
import inspectionScheduleDetail from "@/store/em/inspection/InspectionScheduleDetailStore.js";
import inspectionScheduleTimeoutRecord from "@/store/em/inspection/InspectionScheduleTimeoutRecordStore.js";

const genericEntities = [
    'inspectionSchedule',
    'inspectionScheduleEquipment',
    'inspectionWorkOrder',
    'inspectionRecord',
    'inspectionCategory',
    'inspectionResult',
    'inspectionValueType',
    'inspectionWay',
    'inspectionStandard',
    'inspectionScheduleDetail',
    'inspectionScheduleTimeoutRecord'
]

const entities = {
    inspectionSchedule,
    inspectionScheduleEquipment,
    inspectionWorkOrder,
    inspectionRecord,
    inspectionCategory,
    inspectionResult,
    inspectionValueType,
    inspectionWay,
    inspectionStandard,
    inspectionScheduleDetail,
    inspectionScheduleTimeoutRecord
}

export {genericEntities}

export default entities